// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__HChEC","row":"ProcedureTreatmentSummary_row__3Xxli"};